export default __webpack_public_path__ + "static/media/iMAGE1_iexch.d4e8c69c.jpg";